import React from 'react';
import { ScoreChip } from '../../pages/network/catalogShared';
import { AIP_PLATFORM_LABELS, AipSubscores } from '../../types/aiPresence';

// AI Presence Score pill — the same ScoreChip as PDP / Consumer Voice scores
// with an AI Presence tooltip (discovery / recommendation / per platform when
// the row carries them).
export function AipScoreChip({
  score,
  subscores,
  title,
}: {
  score: number | null | undefined;
  subscores?: AipSubscores | null;
  title?: string;
}) {
  const parts: string[] = [];
  if (subscores) {
    if (subscores.discovery != null) parts.push(`Discovery ${subscores.discovery}`);
    if (subscores.recommendation != null) parts.push(`Recommendation ${subscores.recommendation}`);
    const ps = subscores.platforms || {};
    Object.keys(ps).forEach((k) => {
      if (ps[k] && ps[k].score != null) parts.push(`${AIP_PLATFORM_LABELS[k] || k} ${ps[k].score}`);
    });
  }
  const tip =
    title ||
    `AI Presence Score: how often Claude, Gemini and OpenAI surface and recommend this product${parts.length ? ` · ${parts.join(' · ')}` : ''}`;
  return <ScoreChip score={score} title={tip} />;
}
